import { DictionariesList } from '../components/DictionariesList';

export const DictionariesPage = () => {
  return <DictionariesList />;
};
